module.exports = __webpack_public_path__ + "img/vector_icon.6bb2ec4f.svg";